import React from 'react';
import Panel from './Panel';
import Intranet from '../../components/Panel/ResumeNew/Intranet';
//import Resume from '../../components/Panel/ResumeNew/';




const PessoaJuridicaPage = () => {

    return (
        <Panel>
            <div>
                <Intranet />
            </div>
        </Panel>

    );
};

export default PessoaJuridicaPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/IntranetPage.js
 **/